export const breakpoints = {
  xSmall: 500,
  small: 600,
  medium: 768,
  large: 981
}
